import React, { ReactElement, FC } from 'react'

import Paragraph from '@vfuk/core-paragraph'

import * as Styled from './styles/CompanyInfo.style'

import { CompanyInfoProps } from './CompanyInfo.types'

const CompanyInfo: FC<CompanyInfoProps> = ({ companyInfo, additionalInfo, copyrightText }: CompanyInfoProps): ReactElement => {
  return (
    <Styled.CompanyInfo>
      <If condition={companyInfo}>
        <Paragraph inverse size={1} justify='center'>
          {companyInfo}
        </Paragraph>
      </If>
      <If condition={additionalInfo}>
        <Paragraph inverse size={1} justify='center'>
          {additionalInfo}
        </Paragraph>
      </If>
      <Paragraph inverse size={1} justify='center'>
        {copyrightText}
      </Paragraph>
    </Styled.CompanyInfo>
  )
}

export default CompanyInfo
